import { createApp } from 'vue'
import App from './App.vue'
import installElementPlus from './plugins/element'
import router from '../routes/index'
import store from '../store/index'

import VueGoogleMaps from '@fawmi/vue-google-maps'
import CKEditor from '@ckeditor/ckeditor5-vue';


import {getLocaleData ,setTranslateKeys, getLanguageName,setTranslateRules,getOrderName,filterPublishedTranslates,getImage} from '../src/plugins/helpers'

import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser, faRightFromBracket, faArrowRight, faArrowLeft, faHouse, faPenToSquare, faImage, faEdit, faKey,faEye, faUserPlus, faFloppyDisk, faUpload,faFilePdf,faFileExcel, faArrowsRotate, faAddressCard, faListCheck,faEnvelope,faGear, faTrash,faFileImport,faFileExport,faPlus} from '@fortawesome/free-solid-svg-icons'
import { faCommentDots} from '@fortawesome/free-regular-svg-icons'
// import { far} from '@fortawesome/free-regular-svg-icons'
// import { fab} from '@fortawesome/free-brands-svg-icons'


config.autoAddCss = false
// dom.watch()
// You can add your icons directly in this plugin. See other examples for how you
// can add other styles or just individual icons.
library.add(faUser,faRightFromBracket,faArrowRight,faArrowLeft,faHouse,faPenToSquare, faImage,faEdit, faKey,faEye, faUserPlus, faFloppyDisk, faUpload,faFilePdf,faFileExcel, faArrowsRotate, faAddressCard, faListCheck,faEnvelope,faGear,faCommentDots, faTrash,faFileImport,faFileExport,faPlus)


import VueSidebarMenu from 'vue-sidebar-menu';

import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import '../src/assets/styles/shared.scss'

const app = createApp(App)
app.component("font-awesome-icon", FontAwesomeIcon)
app.use(VueSidebarMenu)
installElementPlus(app)
app.use(store)
app.use(router)
app.config.globalProperties.$getLocaleData = getLocaleData;
app.config.globalProperties.$setTranslateKeys = setTranslateKeys;
app.config.globalProperties.$setTranslateRules = setTranslateRules;
app.config.globalProperties.$getLanguageName = getLanguageName;
app.config.globalProperties.$getOrderName = getOrderName;
app.config.globalProperties.$getImage = getImage;
app.config.globalProperties.$filterPublishedTranslates = filterPublishedTranslates;
app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCrzSWNXX2_8mg7uYZB46JC6XWMPZ0OM5g',
        // language: 'de',
    },
})
app.use( CKEditor )
app.mount('#app')